/**
 * There will be one saga file per component
 */
import { takeEvery, fork, all } from 'redux-saga/effects';
import {
    INITIATE_IMPERSONATION,
    INVALIDATE_IMPERSONATION,
    GET_IMPERSONATION_USERDATA,
} from '../actions';
import getImpersonationKey from './getImpersonationKey';
import invalidateImpersonation from './invalidateImpersonationKey';
import getImpersonationUserData from './getImpersonatedUserData';

function* watchInitiateImpersonation() {
    yield takeEvery(INITIATE_IMPERSONATION, getImpersonationKey);
}
function* watchInvalidImpersonation() {
    yield takeEvery(INVALIDATE_IMPERSONATION, invalidateImpersonation);
}
function* watchgetImpersonationUserData() {
    yield takeEvery(GET_IMPERSONATION_USERDATA, getImpersonationUserData);
}

export default function* ImpersonationSaga() {
    yield all([
        fork(watchInitiateImpersonation),
        fork(watchInvalidImpersonation),
        fork(watchgetImpersonationUserData),
    ]);
}
